export default __webpack_public_path__ + "static/media/menu.57f0133e.svg";